import React, { useEffect, useRef, useState } from "react"

import {
  addReviewClickAnalytics,
  closeReviewModalAnalytics,
  closeSuccessReviewModalAnalytics,
} from "@/components/Review/v1/analytics"
import styles from "@/components/Review/v1/review.module.scss"
import ReactStars from "react-rating-stars-component"
import HalfStar from "@/public/icons/half-star.svg"
import FullStar from "@/public/icons/full-star.svg"
import WhiteStar from "@/public/icons/white-star.svg"
import EmptyStar from "@/public/icons/empty-star.svg"
import Dropdown from "@/components/core/SelectDropdown/SelectDropdown"
import ReviewModal from "@/components/Review/v1/ReviewModal"
import ReviewList from "@/components/Review/v1/ReviewList"
import Button from "@/components/core/Button/Button"
import useWindowResize from "@/hooks/useWindowResize"
import { useDispatch, useSelector } from "react-redux"
import { getProductReviews, selectPdpState } from "@/store/features/pdpSlice"
import Modal from "@/components/core/Modal/Modal"

const ReviewDetail = props => {
  const { data } = props
  const [totalReviews, setTotalReviews] = useState(null)
  const [reviewsList, setReviewsList] = useState([])
  const [filterList, setFilterList] = useState([])
  const [selected, setSelected] = useState("Most Recent")
  const [isOpen, setIsOpen] = useState(false)
  const [ratingValue, setRatingValue] = useState(0)
  const [width] = useWindowResize()
  const [isMobile, setIsMobile] = useState(width < 480)
  const { reviewDetails, productId, productName } = useSelector(selectPdpState)
  const [reviewObject, setReviewObject] = useState(null)
  const [filterRating, setFilterRating] = useState(null)
  const [offset, setOffset] = useState(0)
  const [success, setSuccess] = useState(false)
  const [reviewsCount, setReviewsCount] = useState(null)
  const dispatch = useDispatch()
  const { reviews } = reviewDetails || {}
  const REVIEWS_PER_PAGE = 5
  useEffect(() => {
    setIsMobile(width < 480)
  }, [width])
  // const reviews = []
  const element = document.getElementsByClassName("select-dropdown__display")
  if (element.length) {
    if (width < 480) {
      document.getElementsByClassName(
        "select-dropdown__display"
      )[0].style.display = "none"
    } else {
      document.getElementsByClassName(
        "select-dropdown__display"
      )[0].style.display = "block"
    }
  }
  useEffect(() => {
    if (data) {
      const { sortItems } = data
      let filters = sortItems.map(ele => ele.sortItems)
      // filters = ["Select Option", ...filters]
      setFilterList(filters)
    }
    const element = document.getElementsByClassName("select-dropdown__display")
    if (element.length) {
      if (width < 480) {
        document.getElementsByClassName(
          "select-dropdown__display"
        )[0].style.display = "none"
      } else {
        document.getElementsByClassName(
          "select-dropdown__display"
        )[0].style.display = "block"
      }
    }
  }, [])
  const getCount = star => {
    if (reviewObject) {
      const obj = reviewObject?.ratingsDistribution
      const keys = Object.keys(obj)
      const foundKey = keys?.find(key => key == star)
      if (foundKey) return obj[foundKey]
      else return 0
    } else return 0
  }
  const ratingChanged = newRating => {
    setRatingValue(newRating)
    setIsOpen(true)
    addReviewClickAnalytics()
  }
  const loadMore = () => {
    setOffset(offset + REVIEWS_PER_PAGE)
    dispatch(
      getProductReviews({
        productId: productId,
        offset: offset + REVIEWS_PER_PAGE,
        selected: selected,
        rating: filterRating,
      })
    )
      .then(response => {
        setTotalReviews(response?.payload?.total)
        setReviewsList([...reviewsList, ...response?.payload?.results])
      })
      .catch(err => {
        console.error("Fetching data failed", err)
      })
  }
  useEffect(() => {
    if (productId) {
      dispatch(
        getProductReviews({
          productId: productId,
          offset: offset,
          selected: selected,
          rating: filterRating,
        })
      )
        .then(response => {
          setTotalReviews(response?.payload?.total)
          setReviewsList(response?.payload?.results)
        })
        .catch(err => {
          console.error("Fetching data failed", err)
        })
    }
  }, [productId])
  useEffect(() => {
    if (success) {
      setOffset(0)
      dispatch(
        getProductReviews({
          productId: productId,
          offset: 0,
          selected: selected,
          rating: filterRating,
        })
      )
        .then(response => {
          setTotalReviews(response?.payload?.total)
          setReviewsList(response?.payload?.results)
        })
        .catch(err => {
          console.error("Fetching data failed", err)
        })
    }
  }, [success])
  useEffect(() => {
    if (reviews) {
      setReviewsCount(reviews.count)
      setReviewObject(reviews)
    }
  }, [reviews])
  const getPercentage = star => {
    const { ratingsDistribution } = reviewObject || {}
    const ratingCount = ratingsDistribution?.[star]
    if (ratingCount) {
      const element = document.getElementById(`myBar-${star}`)
      // if (element) element.style.cursor = "pointer"
      return (ratingCount / reviewsCount) * 100
    } else return 0
  }
  const filterBasedOnRating = rating => {
    setFilterRating(rating)
    dispatch(
      getProductReviews({
        productId: productId,
        offset: offset,
        rating: rating,
        selected: selected,
      })
    )
      .then(response => {
        setTotalReviews(response?.payload?.total)
        setReviewsList(response?.payload?.results)
      })
      .catch(err => {
        console.error("Fetching data failed", err)
      })
  }
  const sortHandler = selectedOption => {
    setSelected(selectedOption)
    dispatch(
      getProductReviews({
        productId: productId,
        offset: offset,
        rating: filterRating,
        selected: selectedOption,
      })
    )
      .then(response => {
        setTotalReviews(response?.payload?.total)
        setReviewsList(response?.payload?.results)
      })
      .catch(err => {
        console.error("Fetching data failed", err)
      })
  }
  const closeSuccessModal = () => {
    setSuccess(false)
    closeSuccessReviewModalAnalytics()
  }
  return (
    <div className={styles.reviewContainer}>
      <div className="review-title">Reviews</div>
      {reviewsList?.length > 0 ? (
        <>
          <div className="rating-container">
            <div className="individual-container-1">
              <div className="rating-snapshot">Rating Snapshot</div>
              {/* <div className="filter-title">
                Select a row below to filter reviews.
              </div> */}
              <div>
                {[5, 4, 3, 2, 1].map(star => (
                  <div className="individual-rating">
                    <div className="star-rating">{`${star} star${
                      star === 1 ? "" : "s"
                    }`}</div>
                    <div
                      className="myBar"
                      id={`myBar-${star}`}
                      // onClick={() => filterBasedOnRating(star)}
                    >
                      <div
                        className="rating-bar"
                        id={`rating-bar-${star}`}
                        style={{ width: `${getPercentage(star)}%` }}
                      ></div>
                    </div>

                    <div className="count">{getCount(star)}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="individual-container">
              <div className="rating-snapshot">Overall Rating</div>
              <div className="rating-div">
                <div className="rating">{`${reviewObject?.averageRating?.toFixed(
                  1
                )}`}</div>
                <div>
                  <ReactStars
                    count={5}
                    value={reviewObject?.averageRating?.toFixed(1)}
                    size={24}
                    edit={false}
                    isHalf={true}
                    emptyIcon={<img src={EmptyStar.src} />}
                    halfIcon={<img src={HalfStar.src} />}
                    filledIcon={<img src={FullStar.src} />}
                  />
                  <div className="review-number">{`${reviewsCount} Reviews`}</div>
                </div>
              </div>
              <div className="rating-desc">
                {`${Math.floor(reviewObject?.averageRating)} out of 5 (${
                  (Math.floor(reviewObject?.averageRating) / 5) * 100
                }%) reviewers recommend this product`}
              </div>
            </div>
            <div className="individual-container">
              <div className="rating-snapshot">Review this product</div>
              <div className="filter-title">
                <div>
                  <ReactStars
                    count={5}
                    size={24}
                    emptyIcon={
                      <img src={EmptyStar.src} className="empty-reviews" />
                    }
                    halfIcon={<img src={HalfStar.src} />}
                    filledIcon={
                      <img src={WhiteStar.src} className="filled-reviews" />
                    }
                    onChange={ratingChanged}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="rating-filter-container">
            <div className="rating-heading">{`1 - ${reviewsList?.length} of ${totalReviews} Reviews`}</div>
            {/* <div className="review-filter-heading">
              {`Sort By ${!isMobile ? ":" : ""}`}
              <Dropdown
                customClass="filter-dropdown"
                data={filterList}
                value={selected}
                onChange={selectedOption => sortHandler(selectedOption)}
              />
            </div> */}
          </div>
          <hr />
          <ReviewList reviewsList={reviewsList} />
          {totalReviews > offset + REVIEWS_PER_PAGE && (
            <Button
              label="Load More"
              className="load-more-cta"
              customClass="load-more-cta"
              type="black"
              role="button"
              size="small"
              onClick={loadMore}
            />
          )}
        </>
      ) : (
        <div>
          <div className="no-reviews-text">No Reviews Yet!</div>
          <div className="first-to-review">
            Be the first to share your thoughts on this product.
          </div>
          <ReactStars
            count={5}
            size={24}
            emptyIcon={<img src={EmptyStar.src} className="empty-reviews" />}
            halfIcon={<img src={HalfStar.src} />}
            filledIcon={<img src={WhiteStar.src} className="filled-reviews" />}
            onChange={ratingChanged}
          />
        </div>
      )}

      {isOpen && (
        <ReviewModal
          showModal={isOpen}
          closeModal={() => {
            setIsOpen(false)
            setRatingValue(0)
            closeReviewModalAnalytics()
          }}
          setRatingValue={setRatingValue}
          ratingValue={ratingValue}
          productId={productId}
          setSuccess={setSuccess}
          productName={productName}
          setIsOpen={setIsOpen}
        />
      )}
      {success && (
        <Modal
          showModal={success}
          onModalClose={closeSuccessModal}
          hideCloseIcon={true}
        >
          <div className="review-modal">
            <div className="success-review">Your review was submitted!</div>
            <Button
              label="Close"
              className="submit-cta"
              type="black"
              size="large"
              role="button"
              onClick={closeSuccessModal}
            />
          </div>
        </Modal>
      )}
    </div>
  )
}

ReviewDetail.defaultProps = {
  bazaarVoiceProductId: "",
  productInfo: {},
}

export default ReviewDetail
